module.exports = __webpack_public_path__ + "avatar-placeholder.8ec08b3a5daa6459be10a22d459dee1d.hashedasset.png";


//////////////////
// WEBPACK FOOTER
// ./app/img/users/avatar-placeholder.png
// module id = 1275
// module chunks = 1